// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mission Control Dashboard — GitHub HQ wallboard aesthetic */

.mc-root {
  background: var(--mc-bg);
  color: var(--mc-text-primary);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11', 'tnum';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  font-size: 15px;
  line-height: 1.55;
}

.mc-mono {
  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, monospace;
  font-variant-ligatures: none;
  font-variant-numeric: tabular-nums;
}

.mc-hero-number {
  font-family: 'Inter', system-ui, sans-serif;
  font-weight: 400;
  font-size: clamp(3.75rem, 7vw, 6.25rem);
  line-height: 1;
  letter-spacing: -0.035em;
  color: var(--mc-text-hero);
  font-variant-numeric: tabular-nums;
}

.mc-hero-underline {
  display: inline-block;
  width: 32px;
  height: 3px;
  background: var(--mc-text-accent-pink);
  margin-top: 8px;
}

.mc-hero-number-muted {
  color: var(--mc-text-meta);
}

/* Desktop dashboard density: keep existing panels visible within one viewport. */
.mc-one-screen .mc-panel-label {
  margin-bottom: 0.4rem;
}

.mc-one-screen .mc-action-dock {
  gap: 0.4rem;
}

.mc-one-screen .mc-action-btn {
  padding: 0.58rem 0.75rem;
}

.mc-one-screen .mc-tools-rail-button {
  gap: 0.6rem;
  padding: 0.48rem 0.8rem;
}

.mc-one-screen .mc-tools-rail-button > span:first-child {
  width: 1.45rem;
  height: 1.45rem;
}

.mc-one-screen .mc-tools-rail-label {
  font-size: 0.75rem;
}

.mc-one-screen .mc-tools-rail-vertical [aria-hidden='true'] {
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

/* Bordered panel — the core layout primitive in the reference */
.mc-panel {
  border: 1px solid var(--mc-divider);
  background: var(--mc-surface);
  padding: 1.25rem 1.5rem;
  position: relative;
}

.mc-panel-compact {
  padding: 0.75rem 1rem;
}

.mc-panel-compact > .mc-panel-header {
  margin-bottom: 0.65rem;
}

.mc-panel-compact > .mc-panel-header-bordered {
  padding-bottom: 0.55rem;
}

/* Raised inner row (e.g. Trending Developers rows, room list rows) */
.mc-row {
  background: var(--mc-surface-raised);
  border: 1px solid var(--mc-divider);
  padding: 0.85rem 1rem;
  transition: border-color 160ms ease, background 160ms ease;
}

.mc-row:hover {
  border-color: var(--mc-cyan);
}

.mc-subpanel {
  border: 1px solid var(--mc-divider);
  background: var(--mc-surface-raised);
  padding: 0.85rem 1rem;
}

.mc-subpanel-flush {
  padding: 0;
}

.mc-subpanel-success {
  border-color: rgba(95, 214, 146, 0.38);
  background: rgba(95, 214, 146, 0.1);
}

.mc-subpanel-danger {
  border-color: rgba(244, 122, 165, 0.38);
  background: rgba(244, 122, 165, 0.1);
}

.mc-subpanel-warning {
  border-color: rgba(245, 158, 11, 0.42);
  background: rgba(245, 158, 11, 0.1);
}

.mc-subpanel-accent {
  border-color: rgba(29, 224, 197, 0.38);
  background: rgba(29, 224, 197, 0.08);
}

.mc-section-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mc-compact-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mc-inline-cluster {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.mc-kicker {
  color: var(--mc-text-meta);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.mc-field-label {
  color: var(--mc-cyan);
  font-size: 0.8125rem;
}

.mc-meta-value {
  color: var(--mc-text-primary);
}

.mc-tone-accent {
  color: var(--mc-cyan) !important;
}

.mc-tone-success {
  color: var(--mc-green) !important;
}

.mc-tone-danger {
  color: var(--mc-magenta) !important;
}

.mc-tone-warning {
  color: var(--mc-amber) !important;
}

.mc-status-dot {
  display: inline-block;
  flex-shrink: 0;
  border-radius: 999px;
}

.mc-empty-state {
  padding: 2rem 1rem;
  border: 1px dashed var(--mc-divider);
  background: rgba(6, 12, 24, 0.38);
  text-align: center;
  color: var(--mc-text-meta);
}

.mc-metric-tile {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.45rem 0.5rem;
  border: 1px solid var(--mc-divider);
  background: rgba(6, 12, 24, 0.45);
}

.mc-metric-tile span {
  color: var(--mc-text-meta);
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.mc-metric-tile strong {
  color: var(--mc-text-primary);
  font-weight: 700;
}

/* Panel/card title, e.g. the label above a hero number like "Forked Projects" */
.mc-panel-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--mc-text-label);
  letter-spacing: 0;
  margin-bottom: 0.75rem;
}

/* Hero caption beside a big number, same role as panel-label */
.mc-hero-label {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--mc-text-label);
  letter-spacing: 0.01em;
}

/* Section header inside a panel (e.g. "Data Stream", "Weekly Timeline")
   Regular case — the reference wallboard uses sentence case, not uppercase. */
.mc-section-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--mc-text-label);
  letter-spacing: 0;
}

/* Secondary / caption text */
.mc-meta {
  color: var(--mc-text-meta);
  font-size: 0.8125rem;
  line-height: 1.5;
  letter-spacing: 0;
}

/* Tertiary / dim text — timestamps, SHA fragments, axis labels */
.mc-meta-dim {
  color: var(--mc-text-meta-dim);
  font-size: 0.75rem;
  line-height: 1.5;
}

.mc-divider {
  border-color: var(--mc-divider);
  background-color: var(--mc-divider);
}

.mc-divider-soft {
  border-color: var(--mc-divider-soft);
  background-color: var(--mc-divider-soft);
}

/* Dots for legends & stream bullets */
.mc-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mc-dot-cyan { background: var(--mc-cyan); }
.mc-dot-purple { background: var(--mc-purple); }
.mc-dot-magenta { background: var(--mc-magenta); }
.mc-dot-gray { background: var(--mc-gray); }
.mc-dot-dim { background: var(--mc-divider); }

/* Pulsing ring for active room nodes */
.mc-pulse {
  animation: mcPulse 2.4s ease-in-out infinite;
}

@keyframes mcPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.08);
    opacity: 1;
  }
}

.mc-pulse-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  animation: mcPulseRing 2.4s ease-out infinite;
  pointer-events: none;
}

@keyframes mcPulseRing {
  0% {
    transform: scale(0.95);
    opacity: 0.75;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

/* Data stream entry entrance */
.mc-stream-entry {
  animation: mcStreamIn 320ms ease-out both;
}

@keyframes mcStreamIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/*
 * New-event telegraph animation.
 * Applied to .mc-stream-entry.mc-stream-new.mc-stream-new--telegraph.
 * Keeps the entry in normal document flow while a ::before pseudo paints
 * the animated cyan accent + background wash so layout never shifts.
 */
.mc-stream-new {
  position: relative;
}

.mc-stream-new--telegraph {
  animation: mcStreamTelegraphIn 520ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

.mc-stream-new--telegraph::before {
  content: '';
  position: absolute;
  inset: -2px -4px -2px -6px;
  border-left: 2px solid var(--mc-cyan);
  background: linear-gradient(
    90deg,
    rgba(29, 224, 197, 0.18) 0%,
    rgba(29, 224, 197, 0.06) 35%,
    transparent 90%
  );
  box-shadow: -6px 0 14px -4px rgba(29, 224, 197, 0.55);
  pointer-events: none;
  animation: mcStreamTelegraphFlash 1400ms ease-out both;
}

@keyframes mcStreamTelegraphIn {
  0% {
    opacity: 0;
    transform: translateY(-14px);
  }
  60% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes mcStreamTelegraphFlash {
  0% {
    opacity: 1;
  }
  60% {
    opacity: 0.55;
  }
  100% {
    opacity: 0;
  }
}

/* Hero number tick */
.mc-tick {
  animation: mcTick 450ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes mcTick {
  0% { transform: translateY(8px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}

/* Minimal button styling */
.mc-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1.05rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--mc-white);
  background: transparent;
  border: 1px solid var(--mc-divider);
  border-radius: 4px;
  transition: all 160ms ease;
  cursor: pointer;
  line-height: 1.2;
}

.mc-btn:hover {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.08);
}

.mc-btn-primary {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
}

.mc-btn-primary:hover {
  background: rgba(29, 224, 197, 0.14);
}

/* Inline action dock — primary create actions placed within a panel */
.mc-action-dock {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mc-action-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.75rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--mc-text-primary, var(--mc-white));
  background: var(--mc-surface-raised, rgba(255, 255, 255, 0.03));
  border: 1px solid var(--mc-divider);
  border-radius: 4px;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
}

.mc-action-btn:hover {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
}

.mc-action-btn-primary {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.08);
}

.mc-action-btn-primary:hover {
  background: rgba(29, 224, 197, 0.16);
}

.mc-action-btn-compact {
  min-height: 2.35rem;
  padding: 0.55rem 0.75rem;
}

.mc-action-btn-fit {
  width: auto;
}

.mc-action-btn-icon {
  width: 2rem;
  height: 2rem;
  min-height: 2rem;
  padding: 0;
}

.mc-action-btn-accent {
  color: var(--mc-cyan);
  border-color: rgba(29, 224, 197, 0.46);
  background: rgba(29, 224, 197, 0.1);
}

.mc-action-btn-accent:hover {
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.16);
}

.mc-action-btn-success {
  color: var(--mc-bg);
  border-color: var(--mc-green);
  background: linear-gradient(135deg, var(--mc-green), rgba(29, 224, 197, 0.9));
}

.mc-action-btn-success:hover {
  color: var(--mc-bg);
  border-color: var(--mc-green);
  background: linear-gradient(135deg, rgba(125, 239, 180, 0.98), var(--mc-cyan));
}

.mc-action-btn-danger {
  color: var(--mc-magenta);
  border-color: rgba(244, 122, 165, 0.46);
  background: rgba(244, 122, 165, 0.08);
}

.mc-action-btn-danger:hover {
  color: var(--mc-magenta);
  border-color: var(--mc-magenta);
  background: rgba(244, 122, 165, 0.14);
}

.mc-action-btn-info {
  color: var(--mc-purple);
  border-color: rgba(184, 85, 231, 0.42);
  background: rgba(184, 85, 231, 0.1);
}

.mc-action-btn-info:hover {
  color: var(--mc-purple);
  border-color: var(--mc-purple);
  background: rgba(184, 85, 231, 0.16);
}

.mc-mini-action {
  height: 2rem;
  min-height: 2rem;
  border-width: 1px;
  padding: 0 0.55rem;
  font-size: 0.75rem;
  border-radius: 4px;
}

.mc-mini-action-icon {
  width: 2rem;
  padding: 0;
}

.mc-mini-action-neutral {
  color: var(--mc-text-primary);
  border-color: var(--mc-divider);
  background: var(--mc-surface-raised);
}

.mc-mini-action-neutral:hover {
  color: var(--mc-cyan);
  border-color: rgba(29, 224, 197, 0.42);
  background: rgba(29, 224, 197, 0.08);
}

.mc-mini-action-info {
  color: var(--mc-purple);
  border-color: rgba(184, 85, 231, 0.42);
  background: rgba(184, 85, 231, 0.12);
}

.mc-mini-action-info:hover {
  color: var(--mc-purple);
  background: rgba(184, 85, 231, 0.18);
}

.mc-mini-action-accent {
  color: var(--mc-cyan);
  border-color: rgba(29, 224, 197, 0.42);
  background: rgba(29, 224, 197, 0.1);
}

.mc-mini-action-accent:hover {
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.16);
}

.mc-mini-action-danger {
  color: var(--mc-magenta);
  border-color: rgba(244, 122, 165, 0.42);
  background: rgba(244, 122, 165, 0.1);
}

.mc-mini-action-danger:hover {
  color: var(--mc-magenta);
  background: rgba(244, 122, 165, 0.16);
}

.mc-seat-choice {
  min-height: 4rem;
  width: 100%;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--mc-divider);
  background: var(--mc-surface-raised);
  color: var(--mc-text-primary);
  text-align: left;
}

.mc-seat-choice:hover {
  border-color: rgba(29, 224, 197, 0.48);
  background: rgba(29, 224, 197, 0.08);
  color: var(--mc-text-primary);
}

.mc-seat-choice-selected {
  border-color: rgba(245, 158, 11, 0.64);
  background: rgba(245, 158, 11, 0.1);
}

.mc-seat-choice-selected:hover {
  border-color: var(--mc-amber);
  background: rgba(245, 158, 11, 0.14);
}

.mc-seat-choice-check {
  margin-left: auto;
  display: inline-flex;
  height: 1.35rem;
  width: 1.35rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--mc-divider);
  border-radius: 999px;
  color: transparent;
}

.mc-seat-choice-selected .mc-seat-choice-check {
  border-color: var(--mc-amber);
  background: var(--mc-amber);
  color: var(--mc-bg);
  box-shadow: 0 0 12px rgba(245, 158, 11, 0.42);
}

.mc-seat-tone-1 {
  --mc-seat-color: var(--mc-cyan);
  --mc-seat-border: rgba(29, 224, 197, 0.68);
}

.mc-seat-tone-2 {
  --mc-seat-color: var(--mc-magenta);
  --mc-seat-border: rgba(244, 122, 165, 0.68);
}

.mc-seat-tone-3 {
  --mc-seat-color: var(--mc-purple);
  --mc-seat-border: rgba(184, 85, 231, 0.68);
}

.mc-seat-tone-4 {
  --mc-seat-color: var(--mc-green);
  --mc-seat-border: rgba(95, 214, 146, 0.68);
}

.mc-seat-tone-1,
.mc-seat-tone-2,
.mc-seat-tone-3,
.mc-seat-tone-4 {
  background: var(--mc-seat-color);
  border-color: var(--mc-seat-border);
}

.mc-seat-tone-1:hover,
.mc-seat-tone-2:hover,
.mc-seat-tone-3:hover,
.mc-seat-tone-4:hover,
.mc-seat-tone-1:focus-visible,
.mc-seat-tone-2:focus-visible,
.mc-seat-tone-3:focus-visible,
.mc-seat-tone-4:focus-visible {
  background: var(--mc-seat-color);
  border-color: var(--mc-seat-border);
}

.mc-seat-marker,
.mc-seat-choice-index {
  background: var(--mc-seat-color) !important;
  border-color: var(--mc-seat-border) !important;
}

.mc-seat-marker {
  box-shadow: 0 0 12px var(--mc-seat-border);
}

.mc-seat-choice-index {
  display: inline-flex;
  height: 2.35rem;
  width: 2.35rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.14);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 0.95rem;
  font-weight: 700;
  color: white;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 8px 18px -14px rgba(0, 0, 0, 0.9);
}

.mc-seat-choice-title {
  color: var(--mc-text-primary);
  font-weight: 700;
}

.mc-seat-choice-meta {
  color: var(--mc-text-meta);
  font-size: 0.75rem;
}

.mc-split-preview {
  display: grid;
  gap: 0.65rem;
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(245, 158, 11, 0.08);
}

/* Compact utility chip — for top-of-page navigation/links */
.mc-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.85rem;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--mc-white);
  background: transparent;
  border: 1px solid var(--mc-divider);
  border-radius: 3px;
  line-height: 1.2;
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
  cursor: pointer;
}

.mc-chip:hover {
  color: var(--mc-cyan);
  border-color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.05);
}

.mc-chip-alert {
  color: var(--mc-magenta);
  border-color: rgba(244, 122, 165, 0.45);
}

.mc-chip-alert:hover {
  color: var(--mc-magenta);
  border-color: var(--mc-magenta);
  background: rgba(244, 122, 165, 0.08);
}

.mc-ledger-action {
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  font-size: 0.875rem;
  letter-spacing: 0.01em;
  border-radius: 4px;
  border-width: 1px;
}

.mc-ledger-action-secondary {
  color: var(--mc-amber);
  border-color: rgba(245, 158, 11, 0.55);
  background: rgba(245, 158, 11, 0.08);
}

.mc-ledger-action-secondary:hover {
  color: var(--mc-amber);
  border-color: var(--mc-amber);
  background: rgba(245, 158, 11, 0.14);
}

.mc-ledger-action-primary {
  color: var(--mc-bg);
  border-color: var(--mc-cyan);
  background: linear-gradient(135deg, var(--mc-cyan), rgba(95, 214, 146, 0.94));
  box-shadow: 0 0 0 1px rgba(29, 224, 197, 0.18), 0 12px 28px -16px rgba(29, 224, 197, 0.85);
}

.mc-ledger-action-primary:hover {
  color: var(--mc-bg);
  border-color: var(--mc-cyan);
  background: linear-gradient(135deg, var(--mc-cyan), rgba(125, 239, 180, 0.98));
  box-shadow: 0 0 0 1px rgba(29, 224, 197, 0.28), 0 16px 34px -16px rgba(29, 224, 197, 0.95);
}

.mc-payment-action {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.5rem;
  width: 100%;
  justify-content: center;
  border: 1px solid var(--mc-divider);
  border-radius: 4px;
  font-size: 0.8125rem;
  font-weight: 600;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;
}

.mc-payment-action-accent {
  color: var(--mc-cyan);
  border-color: rgba(29, 224, 197, 0.42);
  background: rgba(29, 224, 197, 0.1);
}

.mc-payment-action-accent:hover {
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.16);
}

.mc-payment-action-success {
  color: var(--mc-green);
  border-color: rgba(95, 214, 146, 0.42);
  background: rgba(95, 214, 146, 0.1);
}

.mc-payment-action-success:hover {
  color: var(--mc-green);
  background: rgba(95, 214, 146, 0.16);
}

.mc-payment-action-danger {
  color: var(--mc-magenta);
  border-color: rgba(244, 122, 165, 0.42);
  background: rgba(244, 122, 165, 0.1);
}

.mc-payment-action-danger:hover {
  color: var(--mc-magenta);
  background: rgba(244, 122, 165, 0.16);
}

.mc-receipt-focus-row {
  border-radius: 6px;
  outline: 1px solid rgba(244, 122, 165, 0.65);
  outline-offset: 4px;
  box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.12), 0 0 24px rgba(244, 122, 165, 0.18);
  animation: mcReceiptFocus 1.35s ease-in-out 3;
}

@keyframes mcReceiptFocus {
  0%, 100% {
    box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.12), 0 0 20px rgba(244, 122, 165, 0.16);
  }
  50% {
    box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.28), 0 0 34px rgba(244, 122, 165, 0.36);
  }
}

.mc-receipt-error-pulse {
  animation: mcReceiptErrorPulse 2.2s ease-in-out infinite;
}

@keyframes mcReceiptErrorPulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(244, 122, 165, 0.18);
  }
  50% {
    box-shadow: 0 0 0 3px rgba(244, 122, 165, 0.14), 0 0 22px rgba(244, 122, 165, 0.22);
  }
}

.mc-chip-badge {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--mc-magenta);
}

/* Floating action cluster — primary POS actions, always reachable */
.mc-fab-cluster {
  position: fixed;
  right: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 40;
}

@media (min-width: 1536px) {
  .mc-fab-cluster {
    right: 244px;
  }
}

.mc-fab {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.85rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: 1px solid var(--mc-divider);
  background: var(--mc-bg);
  color: var(--mc-white);
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 0 8px 24px -10px rgba(0, 0, 0, 0.7);
  transition: all 160ms ease;
}

.mc-fab:hover {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
}

.mc-fab-primary {
  border-color: var(--mc-cyan);
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.08);
}

.mc-fab-primary:hover {
  background: rgba(29, 224, 197, 0.16);
}

.mc-fab-secondary {
  color: var(--mc-purple, #b855e7);
  border-color: rgba(184, 85, 231, 0.4);
}

.mc-fab-secondary:hover {
  color: var(--mc-purple, #b855e7);
  border-color: var(--mc-purple, #b855e7);
  background: rgba(184, 85, 231, 0.06);
}

/* Tab underline style */
.mc-tab {
  padding: 0.85rem 1.15rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--mc-gray);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: color 160ms ease, border-color 160ms ease;
}

.mc-tab:hover { color: var(--mc-white); }

.mc-tab[data-state='active'],
.mc-tab.mc-tab-active {
  color: var(--mc-cyan);
  border-bottom-color: var(--mc-cyan);
}

/* Venue node */
.mc-node {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid var(--mc-divider);
  background: radial-gradient(circle at 50% 50%, rgba(29, 224, 197, 0.05), transparent 70%);
  transition: all 200ms ease;
}

.mc-node-occupied {
  border-color: var(--mc-cyan);
  background: radial-gradient(circle at 50% 50%, rgba(29, 224, 197, 0.22), transparent 70%);
  box-shadow: 0 0 24px rgba(29, 224, 197, 0.35), inset 0 0 24px rgba(29, 224, 197, 0.1);
}

.mc-node-completed {
  border-color: var(--mc-purple);
  background: radial-gradient(circle at 50% 50%, rgba(184, 85, 231, 0.18), transparent 70%);
  box-shadow: 0 0 18px rgba(184, 85, 231, 0.25);
}

.mc-node-maintenance {
  border-color: var(--mc-gray);
  background: repeating-linear-gradient(
    45deg,
    transparent 0 4px,
    rgba(139, 148, 158, 0.08) 4px 8px
  );
}

/* Mobile */
@media (max-width: 768px) {
  .mc-hero-number {
    font-size: clamp(2.5rem, 10vw, 3.5rem);
  }
  .mc-node {
    width: 64px;
    height: 64px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .mc-pulse,
  .mc-pulse-ring,
  .mc-stream-entry,
  .mc-stream-new--telegraph,
  .mc-stream-new--telegraph::before,
  .mc-attn-pulse,
  .mc-receipt-focus-row,
  .mc-receipt-error-pulse,
  .mc-tick {
    animation: none !important;
  }
  .mc-node,
  .mc-btn,
  .mc-tab {
    transition: none !important;
  }
}

/* Room tile hover */
.mc-room-tile {
  transition: background-color 140ms ease-out, border-color 140ms ease-out;
}
.mc-room-tile:hover {
  background: var(--mc-bg-raised, rgba(29, 224, 197, 0.03)) !important;
}

/*
 * Attention bell (MCAttentionBell)
 * Header glyph + popover list of actionable items.
 */
.mc-attn-bell {
  background: transparent;
}
.mc-attn-bell:hover {
  background: var(--mc-bg-raised, rgba(255, 255, 255, 0.03));
}
.mc-attn-bell:hover:not([data-has-items]) {
  color: var(--mc-cyan) !important;
}

.mc-attn-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 14px;
  height: 14px;
  padding: 0 4px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  color: #0c0f14;
  letter-spacing: 0;
  box-shadow: 0 0 0 1.5px var(--mc-bg, #0a0d12);
}

.mc-attn-pulse {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1.5px solid;
  pointer-events: none;
  animation: mcAttnPulse 1.4s ease-out infinite;
}

@keyframes mcAttnPulse {
  0% {
    transform: scale(0.8);
    opacity: 0.7;
  }
  80% {
    transform: scale(1.6);
    opacity: 0;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

/* Popover open/close animation. Radix sets data-state on PopoverContent. */
.mc-attn-popover[data-state='open'] {
  animation: mcAttnPopoverIn 180ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.mc-attn-popover[data-state='closed'] {
  animation: mcAttnPopoverOut 120ms ease-in both;
}

@keyframes mcAttnPopoverIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes mcAttnPopoverOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* Row hover — uses the same raised surface as other MC affordances */
.mc-attn-row > button:hover {
  background: var(--mc-bg-raised, rgba(29, 224, 197, 0.04));
}

/* Resolving row: fade then collapse. Parent sets data-resolving="true". */
.mc-attn-row[data-resolving='true'] {
  animation: mcAttnRowOut 350ms ease-in forwards;
  overflow: hidden;
}

.mc-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.mc-panel-header-tight {
  margin-bottom: 0.5rem;
}

.mc-panel-header-flush {
  margin-bottom: 0;
}

.mc-panel-header-bordered {
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--mc-divider-soft);
}

.mc-panel-header-title {
  min-width: 0;
}

.mc-panel-header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex-shrink: 0;
}

.mc-scroll-thin {
  scrollbar-width: thin;
}

.mc-scroll-none {
  scrollbar-width: none;
}

.mc-popover-panel {
  box-shadow: 0 8px 32px rgba(29, 224, 197, 0.08), 0 2px 8px rgba(0, 0, 0, 0.4);
}

.mc-popover-content {
  background: var(--mc-surface-raised, #0f1628);
  border: 1px solid var(--mc-divider);
  color: var(--mc-text-primary, var(--mc-white));
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
}

.mc-dialog-content {
  background: var(--mc-surface-raised, #0f1628);
  border: 1px solid var(--mc-divider);
  color: var(--mc-text-primary, var(--mc-white));
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.46), 0 0 28px rgba(29, 224, 197, 0.08);
}

.mc-dialog-frame {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(15, 22, 40, 0.96) 0%, rgba(8, 12, 22, 0.96) 100%);
}

.mc-dialog-frame-accent {
  position: absolute;
  inset-inline: 0;
  top: 0;
  height: 1px;
}

.mc-dialog-header {
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid var(--mc-divider);
}

.mc-dialog-body {
  padding: 1rem 1.25rem;
}

.mc-dialog-footer {
  padding: 0.625rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-top: 1px solid var(--mc-divider);
}

.mc-dialog-footer-end {
  justify-content: flex-end;
}

.mc-input {
  background: transparent;
  border: 1px solid var(--mc-divider);
  border-radius: 4px;
  color: var(--mc-text-primary, var(--mc-white));
  padding: 0.5rem 0.75rem;
  outline: none;
}

.mc-input.mc-input-currency {
  padding-left: 1.9rem;
}

.mc-input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.mc-input[type='number']::-webkit-outer-spin-button,
.mc-input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.mc-input:focus {
  border-color: var(--mc-cyan);
}

.mc-code-block {
  color: var(--mc-text-primary);
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid var(--mc-divider-soft);
  border-radius: 3px;
}

.mc-status-badge {
  border-width: 1px;
  letter-spacing: 0.04em;
}

.mc-status-info {
  color: var(--mc-purple);
  border-color: rgba(184, 85, 231, 0.42);
  background: rgba(184, 85, 231, 0.14);
}

.mc-status-success {
  color: var(--mc-green);
  border-color: rgba(95, 214, 146, 0.42);
  background: rgba(95, 214, 146, 0.14);
}

.mc-status-danger {
  color: var(--mc-magenta);
  border-color: rgba(244, 122, 165, 0.42);
  background: rgba(244, 122, 165, 0.14);
}

.mc-status-warning {
  color: var(--mc-amber);
  border-color: rgba(245, 158, 11, 0.42);
  background: rgba(245, 158, 11, 0.12);
}

@keyframes mcAttnRowOut {
  0% {
    opacity: 1;
    max-height: 120px;
  }
  40% {
    opacity: 0;
    max-height: 120px;
  }
  100% {
    opacity: 0;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    border-top-width: 0;
  }
}

/* Original booking-detail layout prototype, rethemed with Mission Control tokens. */
.mc-original-layout {
  color: var(--mc-text-primary);
}

.mc-booking-shell {
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  padding: 1rem 0.75rem;
}

@media (min-width: 640px) {
  .mc-booking-shell {
    padding: 2rem 1.5rem;
  }
}

.mc-booking-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (min-width: 1024px) {
  .mc-booking-layout {
    grid-template-columns: minmax(0, 2fr) minmax(19rem, 1fr);
  }
}

.mc-booking-main,
.mc-booking-side {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1rem;
}

.mc-seat-detail-panel {
  overflow: hidden;
  padding: 0 !important;
}

.mc-seat-detail-header {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--mc-divider-soft);
}

.mc-seat-detail-body {
  padding: 0.5rem 1rem 1rem;
}

@media (min-width: 640px) {
  .mc-seat-detail-header {
    padding: 1rem 1.5rem;
  }

  .mc-seat-detail-body {
    padding: 0.5rem 1.5rem 1.5rem;
  }
}

.mc-original-layout [class*='bg-slate-800'],
.mc-original-layout [class*='bg-slate-900'] {
  background: var(--mc-surface) !important;
}

.mc-original-layout [class*='border-slate'] {
  border-color: var(--mc-divider) !important;
}

.mc-original-layout [class*='text-slate-200'],
.mc-original-layout [class*='text-slate-300'],
.mc-original-layout [class*='text-slate-400'],
.mc-original-layout [class*='text-white'] {
  color: var(--mc-text-primary) !important;
}

.mc-original-layout [class*='text-slate-500'] {
  color: var(--mc-text-meta-dim) !important;
}

.mc-original-layout [class*='text-amber-400'],
.mc-original-layout .group:hover [class*='group-hover:text-amber-400'] {
  color: var(--mc-cyan) !important;
}

.mc-original-layout [class*='bg-amber-500'],
.mc-original-layout [class*='bg-amber-600'],
.mc-original-layout [class*='from-amber'],
.mc-original-layout [class*='to-orange'] {
  background: rgba(29, 224, 197, 0.16) !important;
}

.mc-original-layout [class*='border-amber'],
.mc-original-layout [class*='hover:border-amber'] {
  border-color: rgba(29, 224, 197, 0.46) !important;
}

.mc-original-layout [class*='hover:bg-amber']:hover {
  background: rgba(29, 224, 197, 0.1) !important;
}

.mc-original-layout button.bg-amber-500 {
  color: var(--mc-bg) !important;
  border-color: var(--mc-cyan) !important;
  background: linear-gradient(135deg, var(--mc-cyan), rgba(95, 214, 146, 0.94)) !important;
}

.mc-original-layout [class*='bg-green'],
.mc-original-layout [class*='bg-emerald'] {
  background: rgba(95, 214, 146, 0.16) !important;
}

.mc-original-layout [class*='text-green'],
.mc-original-layout [class*='text-emerald'] {
  color: var(--mc-green) !important;
}

.mc-original-layout [class*='border-green'],
.mc-original-layout [class*='border-emerald'] {
  border-color: rgba(95, 214, 146, 0.42) !important;
}

.mc-original-layout [class*='bg-red'] {
  background: rgba(244, 122, 165, 0.12) !important;
}

.mc-original-layout [class*='text-red'] {
  color: var(--mc-magenta) !important;
}

.mc-original-layout [class*='border-red'] {
  border-color: rgba(244, 122, 165, 0.42) !important;
}

.mc-original-layout [class*='bg-blue'],
.mc-original-layout [class*='bg-sky'],
.mc-original-layout [class*='bg-purple'],
.mc-original-layout [class*='bg-pink'],
.mc-original-layout [class*='from-purple'],
.mc-original-layout [class*='to-pink'],
.mc-original-layout [class*='from-sky'],
.mc-original-layout [class*='to-blue'] {
  background: rgba(184, 85, 231, 0.14) !important;
}

.mc-original-layout [class*='text-blue'],
.mc-original-layout [class*='text-purple'] {
  color: var(--mc-purple) !important;
}

.mc-original-layout [class*='border-blue'],
.mc-original-layout [class*='border-purple'] {
  border-color: rgba(184, 85, 231, 0.42) !important;
}

.mc-original-layout [class*='bg-gradient-to-r'] {
  background-image: linear-gradient(90deg, var(--mc-cyan), var(--mc-purple)) !important;
}

.mc-original-layout [role='tablist'] {
  background: var(--mc-surface-raised) !important;
  border: 1px solid var(--mc-divider);
}

.mc-original-layout [role='tab'] {
  color: var(--mc-text-meta);
}

.mc-original-layout [role='tab'][data-state='active'] {
  color: var(--mc-cyan);
  background: rgba(29, 224, 197, 0.1);
}

.mc-original-layout button {
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.mc-original-layout .border-t .mc-payment-action {
  margin-left: -1px;
  width: calc(100% + 2px);
}

.mc-original-layout .mc-booking-command-compact {
  padding: 0.65rem 1rem;
}

.mc-original-layout .mc-booking-meta-line {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1.25rem;
  color: var(--mc-text-meta);
  font-size: 0.8125rem;
  line-height: 1.35;
}

.mc-original-layout .mc-booking-meta-item {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 0.45rem;
  white-space: nowrap;
}

.mc-original-layout .mc-seat-count-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem;
  border: 1px solid var(--mc-divider) !important;
  background: var(--mc-surface-raised) !important;
}

.mc-original-layout .mc-payment-total-compact {
  padding: 0.7rem 0.8rem !important;
}

.mc-original-layout .mc-payment-seat-compact {
  padding: 0.65rem;
  border: 1px solid var(--mc-divider);
  background: var(--mc-surface-raised);
}

.mc-original-layout .mc-payment-seat-compact .mc-panel-header {
  align-items: center;
  gap: 0.75rem;
}

.mc-original-layout .mc-payment-seat-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.75rem;
  padding: 0.42rem 0.55rem;
  border: 1px solid transparent !important;
  border-radius: 0.45rem;
  background: rgba(6, 12, 24, 0.5) !important;
  font-size: 0.8125rem;
  text-align: left;
}

.mc-original-layout .mc-payment-seat-status:hover {
  border-color: rgba(29, 224, 197, 0.35) !important;
  background: rgba(29, 224, 197, 0.06) !important;
}

.mc-original-layout .mc-payment-seat-status-active {
  border-color: rgba(29, 224, 197, 0.55) !important;
  background: rgba(29, 224, 197, 0.1) !important;
  box-shadow: inset 0 0 14px rgba(29, 224, 197, 0.05);
}

.mc-original-layout .mc-menu-tool {
  height: auto;
  min-height: 2.5rem;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid var(--mc-divider) !important;
  background: var(--mc-surface-raised) !important;
  color: var(--mc-text-primary) !important;
  font-size: 0.8125rem;
  font-weight: 500;
}

.mc-original-layout .mc-menu-tool:hover {
  border-color: rgba(29, 224, 197, 0.45) !important;
  background: rgba(29, 224, 197, 0.08) !important;
  color: var(--mc-cyan) !important;
}

.mc-original-layout .mc-menu-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.7rem 0.85rem;
  border: 1px solid var(--mc-divider) !important;
  border-radius: 0.4rem;
  background: var(--mc-surface-raised) !important;
  text-align: left;
}

.mc-original-layout .mc-menu-item:hover {
  border-color: rgba(29, 224, 197, 0.45) !important;
  background: rgba(29, 224, 197, 0.07) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mission-control.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAI9D;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,0DAA0D;EAC1D,6DAA6D;EAC7D,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sEAAsE;EACtE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,wBAAwB;EACxB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iFAAiF;AACjF;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;8EAC8E;AAC9E;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe,0BAA0B,EAAE;AAC3C,iBAAiB,4BAA4B,EAAE;AAC/C,kBAAkB,6BAA6B,EAAE;AACjD,eAAe,0BAA0B,EAAE;AAC3C,cAAc,6BAA6B,EAAE;;AAE7C,uCAAuC;AACvC;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;EAKE;AACF;EACE,kBAAkB;AACpB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC;;;;;GAKC;EACD,qDAAqD;EACrD,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,yDAAyD;AAC3D;;AAEA;EACE,KAAK,0BAA0B,EAAE,UAAU,EAAE;EAC7C,OAAO,wBAAwB,EAAE,UAAU,EAAE;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,+DAA+D;EAC/D,mCAAmC;EACnC,kBAAkB;EAClB,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8EAA8E;AAChF;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;;;;EAIE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,gGAAgG;EAChG,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0FAA0F;AAC5F;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,4EAA4E;EAC5E,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6EAA6E;EAC7E,0FAA0F;AAC5F;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,8EAA8E;EAC9E,0FAA0F;AAC5F;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,mFAAmF;EACnF,6CAA6C;AAC/C;;AAEA;EACE;IACE,mFAAmF;EACrF;EACA;IACE,mFAAmF;EACrF;AACF;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,mFAAmF;EACrF;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;EACf,qDAAqD;AACvD;;AAEA,gBAAgB,sBAAsB,EAAE;;AAExC;;EAEE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,yFAAyF;EACzF,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yFAAyF;EACzF,qFAAqF;AACvF;;AAEA;EACE,8BAA8B;EAC9B,yFAAyF;EACzF,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA,WAAW;AACX;EACE;IACE,sCAAsC;EACxC;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;;;;;IASE,0BAA0B;EAC5B;EACA;;;IAGE,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;AACpB;EACE,wEAAwE;AAC1E;AACA;EACE,oEAAoE;AACtE;;AAEA;;;EAGE;AACF;EACE,uBAAuB;AACzB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,2EAA2E;AAC3E;EACE,mEAAmE;AACrE;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qEAAqE;AACrE;EACE,yDAAyD;AAC3D;;AAEA,0EAA0E;AAC1E;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,8CAA8C;EAC9C,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;EAC9C,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,oFAAoF;AACpF;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,wDAAwD;EAC1D;AACF;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,wFAAwF;AAC1F;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;;;;;;EAQE,+CAA+C;AACjD;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;EACjD,8CAA8C;EAC9C,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,8CAA8C;EAC9C,+CAA+C;EAC/C,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,8CAA8C;EAC9C,qBAAqB;EACrB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD","sourcesContent":["/* Mission Control Dashboard — GitHub HQ wallboard aesthetic */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');\n\n.mc-root {\n  background: var(--mc-bg);\n  color: var(--mc-text-primary);\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11', 'tnum';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100vh;\n  font-size: 15px;\n  line-height: 1.55;\n}\n\n.mc-mono {\n  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, monospace;\n  font-variant-ligatures: none;\n  font-variant-numeric: tabular-nums;\n}\n\n.mc-hero-number {\n  font-family: 'Inter', system-ui, sans-serif;\n  font-weight: 400;\n  font-size: clamp(3.75rem, 7vw, 6.25rem);\n  line-height: 1;\n  letter-spacing: -0.035em;\n  color: var(--mc-text-hero);\n  font-variant-numeric: tabular-nums;\n}\n\n.mc-hero-underline {\n  display: inline-block;\n  width: 32px;\n  height: 3px;\n  background: var(--mc-text-accent-pink);\n  margin-top: 8px;\n}\n\n.mc-hero-number-muted {\n  color: var(--mc-text-meta);\n}\n\n/* Desktop dashboard density: keep existing panels visible within one viewport. */\n.mc-one-screen .mc-panel-label {\n  margin-bottom: 0.4rem;\n}\n\n.mc-one-screen .mc-action-dock {\n  gap: 0.4rem;\n}\n\n.mc-one-screen .mc-action-btn {\n  padding: 0.58rem 0.75rem;\n}\n\n.mc-one-screen .mc-tools-rail-button {\n  gap: 0.6rem;\n  padding: 0.48rem 0.8rem;\n}\n\n.mc-one-screen .mc-tools-rail-button > span:first-child {\n  width: 1.45rem;\n  height: 1.45rem;\n}\n\n.mc-one-screen .mc-tools-rail-label {\n  font-size: 0.75rem;\n}\n\n.mc-one-screen .mc-tools-rail-vertical [aria-hidden='true'] {\n  margin-left: 0.8rem;\n  margin-right: 0.8rem;\n}\n\n/* Bordered panel — the core layout primitive in the reference */\n.mc-panel {\n  border: 1px solid var(--mc-divider);\n  background: var(--mc-surface);\n  padding: 1.25rem 1.5rem;\n  position: relative;\n}\n\n.mc-panel-compact {\n  padding: 0.75rem 1rem;\n}\n\n.mc-panel-compact > .mc-panel-header {\n  margin-bottom: 0.65rem;\n}\n\n.mc-panel-compact > .mc-panel-header-bordered {\n  padding-bottom: 0.55rem;\n}\n\n/* Raised inner row (e.g. Trending Developers rows, room list rows) */\n.mc-row {\n  background: var(--mc-surface-raised);\n  border: 1px solid var(--mc-divider);\n  padding: 0.85rem 1rem;\n  transition: border-color 160ms ease, background 160ms ease;\n}\n\n.mc-row:hover {\n  border-color: var(--mc-cyan);\n}\n\n.mc-subpanel {\n  border: 1px solid var(--mc-divider);\n  background: var(--mc-surface-raised);\n  padding: 0.85rem 1rem;\n}\n\n.mc-subpanel-flush {\n  padding: 0;\n}\n\n.mc-subpanel-success {\n  border-color: rgba(95, 214, 146, 0.38);\n  background: rgba(95, 214, 146, 0.1);\n}\n\n.mc-subpanel-danger {\n  border-color: rgba(244, 122, 165, 0.38);\n  background: rgba(244, 122, 165, 0.1);\n}\n\n.mc-subpanel-warning {\n  border-color: rgba(245, 158, 11, 0.42);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.mc-subpanel-accent {\n  border-color: rgba(29, 224, 197, 0.38);\n  background: rgba(29, 224, 197, 0.08);\n}\n\n.mc-section-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.mc-compact-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.mc-inline-cluster {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mc-kicker {\n  color: var(--mc-text-meta);\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.mc-field-label {\n  color: var(--mc-cyan);\n  font-size: 0.8125rem;\n}\n\n.mc-meta-value {\n  color: var(--mc-text-primary);\n}\n\n.mc-tone-accent {\n  color: var(--mc-cyan) !important;\n}\n\n.mc-tone-success {\n  color: var(--mc-green) !important;\n}\n\n.mc-tone-danger {\n  color: var(--mc-magenta) !important;\n}\n\n.mc-tone-warning {\n  color: var(--mc-amber) !important;\n}\n\n.mc-status-dot {\n  display: inline-block;\n  flex-shrink: 0;\n  border-radius: 999px;\n}\n\n.mc-empty-state {\n  padding: 2rem 1rem;\n  border: 1px dashed var(--mc-divider);\n  background: rgba(6, 12, 24, 0.38);\n  text-align: center;\n  color: var(--mc-text-meta);\n}\n\n.mc-metric-tile {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.45rem 0.5rem;\n  border: 1px solid var(--mc-divider);\n  background: rgba(6, 12, 24, 0.45);\n}\n\n.mc-metric-tile span {\n  color: var(--mc-text-meta);\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.mc-metric-tile strong {\n  color: var(--mc-text-primary);\n  font-weight: 700;\n}\n\n/* Panel/card title, e.g. the label above a hero number like \"Forked Projects\" */\n.mc-panel-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--mc-text-label);\n  letter-spacing: 0;\n  margin-bottom: 0.75rem;\n}\n\n/* Hero caption beside a big number, same role as panel-label */\n.mc-hero-label {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: var(--mc-text-label);\n  letter-spacing: 0.01em;\n}\n\n/* Section header inside a panel (e.g. \"Data Stream\", \"Weekly Timeline\")\n   Regular case — the reference wallboard uses sentence case, not uppercase. */\n.mc-section-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--mc-text-label);\n  letter-spacing: 0;\n}\n\n/* Secondary / caption text */\n.mc-meta {\n  color: var(--mc-text-meta);\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  letter-spacing: 0;\n}\n\n/* Tertiary / dim text — timestamps, SHA fragments, axis labels */\n.mc-meta-dim {\n  color: var(--mc-text-meta-dim);\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n\n.mc-divider {\n  border-color: var(--mc-divider);\n  background-color: var(--mc-divider);\n}\n\n.mc-divider-soft {\n  border-color: var(--mc-divider-soft);\n  background-color: var(--mc-divider-soft);\n}\n\n/* Dots for legends & stream bullets */\n.mc-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.mc-dot-cyan { background: var(--mc-cyan); }\n.mc-dot-purple { background: var(--mc-purple); }\n.mc-dot-magenta { background: var(--mc-magenta); }\n.mc-dot-gray { background: var(--mc-gray); }\n.mc-dot-dim { background: var(--mc-divider); }\n\n/* Pulsing ring for active room nodes */\n.mc-pulse {\n  animation: mcPulse 2.4s ease-in-out infinite;\n}\n\n@keyframes mcPulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1.08);\n    opacity: 1;\n  }\n}\n\n.mc-pulse-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  animation: mcPulseRing 2.4s ease-out infinite;\n  pointer-events: none;\n}\n\n@keyframes mcPulseRing {\n  0% {\n    transform: scale(0.95);\n    opacity: 0.75;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n\n/* Data stream entry entrance */\n.mc-stream-entry {\n  animation: mcStreamIn 320ms ease-out both;\n}\n\n@keyframes mcStreamIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/*\n * New-event telegraph animation.\n * Applied to .mc-stream-entry.mc-stream-new.mc-stream-new--telegraph.\n * Keeps the entry in normal document flow while a ::before pseudo paints\n * the animated cyan accent + background wash so layout never shifts.\n */\n.mc-stream-new {\n  position: relative;\n}\n\n.mc-stream-new--telegraph {\n  animation: mcStreamTelegraphIn 520ms cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n.mc-stream-new--telegraph::before {\n  content: '';\n  position: absolute;\n  inset: -2px -4px -2px -6px;\n  border-left: 2px solid var(--mc-cyan);\n  background: linear-gradient(\n    90deg,\n    rgba(29, 224, 197, 0.18) 0%,\n    rgba(29, 224, 197, 0.06) 35%,\n    transparent 90%\n  );\n  box-shadow: -6px 0 14px -4px rgba(29, 224, 197, 0.55);\n  pointer-events: none;\n  animation: mcStreamTelegraphFlash 1400ms ease-out both;\n}\n\n@keyframes mcStreamTelegraphIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-14px);\n  }\n  60% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes mcStreamTelegraphFlash {\n  0% {\n    opacity: 1;\n  }\n  60% {\n    opacity: 0.55;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Hero number tick */\n.mc-tick {\n  animation: mcTick 450ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes mcTick {\n  0% { transform: translateY(8px); opacity: 0; }\n  100% { transform: translateY(0); opacity: 1; }\n}\n\n/* Minimal button styling */\n.mc-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 1.05rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--mc-white);\n  background: transparent;\n  border: 1px solid var(--mc-divider);\n  border-radius: 4px;\n  transition: all 160ms ease;\n  cursor: pointer;\n  line-height: 1.2;\n}\n\n.mc-btn:hover {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.08);\n}\n\n.mc-btn-primary {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n}\n\n.mc-btn-primary:hover {\n  background: rgba(29, 224, 197, 0.14);\n}\n\n/* Inline action dock — primary create actions placed within a panel */\n.mc-action-dock {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.mc-action-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.75rem 0.9rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--mc-text-primary, var(--mc-white));\n  background: var(--mc-surface-raised, rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--mc-divider);\n  border-radius: 4px;\n  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;\n  cursor: pointer;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.mc-action-btn:hover {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n}\n\n.mc-action-btn-primary {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.08);\n}\n\n.mc-action-btn-primary:hover {\n  background: rgba(29, 224, 197, 0.16);\n}\n\n.mc-action-btn-compact {\n  min-height: 2.35rem;\n  padding: 0.55rem 0.75rem;\n}\n\n.mc-action-btn-fit {\n  width: auto;\n}\n\n.mc-action-btn-icon {\n  width: 2rem;\n  height: 2rem;\n  min-height: 2rem;\n  padding: 0;\n}\n\n.mc-action-btn-accent {\n  color: var(--mc-cyan);\n  border-color: rgba(29, 224, 197, 0.46);\n  background: rgba(29, 224, 197, 0.1);\n}\n\n.mc-action-btn-accent:hover {\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.16);\n}\n\n.mc-action-btn-success {\n  color: var(--mc-bg);\n  border-color: var(--mc-green);\n  background: linear-gradient(135deg, var(--mc-green), rgba(29, 224, 197, 0.9));\n}\n\n.mc-action-btn-success:hover {\n  color: var(--mc-bg);\n  border-color: var(--mc-green);\n  background: linear-gradient(135deg, rgba(125, 239, 180, 0.98), var(--mc-cyan));\n}\n\n.mc-action-btn-danger {\n  color: var(--mc-magenta);\n  border-color: rgba(244, 122, 165, 0.46);\n  background: rgba(244, 122, 165, 0.08);\n}\n\n.mc-action-btn-danger:hover {\n  color: var(--mc-magenta);\n  border-color: var(--mc-magenta);\n  background: rgba(244, 122, 165, 0.14);\n}\n\n.mc-action-btn-info {\n  color: var(--mc-purple);\n  border-color: rgba(184, 85, 231, 0.42);\n  background: rgba(184, 85, 231, 0.1);\n}\n\n.mc-action-btn-info:hover {\n  color: var(--mc-purple);\n  border-color: var(--mc-purple);\n  background: rgba(184, 85, 231, 0.16);\n}\n\n.mc-mini-action {\n  height: 2rem;\n  min-height: 2rem;\n  border-width: 1px;\n  padding: 0 0.55rem;\n  font-size: 0.75rem;\n  border-radius: 4px;\n}\n\n.mc-mini-action-icon {\n  width: 2rem;\n  padding: 0;\n}\n\n.mc-mini-action-neutral {\n  color: var(--mc-text-primary);\n  border-color: var(--mc-divider);\n  background: var(--mc-surface-raised);\n}\n\n.mc-mini-action-neutral:hover {\n  color: var(--mc-cyan);\n  border-color: rgba(29, 224, 197, 0.42);\n  background: rgba(29, 224, 197, 0.08);\n}\n\n.mc-mini-action-info {\n  color: var(--mc-purple);\n  border-color: rgba(184, 85, 231, 0.42);\n  background: rgba(184, 85, 231, 0.12);\n}\n\n.mc-mini-action-info:hover {\n  color: var(--mc-purple);\n  background: rgba(184, 85, 231, 0.18);\n}\n\n.mc-mini-action-accent {\n  color: var(--mc-cyan);\n  border-color: rgba(29, 224, 197, 0.42);\n  background: rgba(29, 224, 197, 0.1);\n}\n\n.mc-mini-action-accent:hover {\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.16);\n}\n\n.mc-mini-action-danger {\n  color: var(--mc-magenta);\n  border-color: rgba(244, 122, 165, 0.42);\n  background: rgba(244, 122, 165, 0.1);\n}\n\n.mc-mini-action-danger:hover {\n  color: var(--mc-magenta);\n  background: rgba(244, 122, 165, 0.16);\n}\n\n.mc-seat-choice {\n  min-height: 4rem;\n  width: 100%;\n  justify-content: flex-start;\n  gap: 0.75rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid var(--mc-divider);\n  background: var(--mc-surface-raised);\n  color: var(--mc-text-primary);\n  text-align: left;\n}\n\n.mc-seat-choice:hover {\n  border-color: rgba(29, 224, 197, 0.48);\n  background: rgba(29, 224, 197, 0.08);\n  color: var(--mc-text-primary);\n}\n\n.mc-seat-choice-selected {\n  border-color: rgba(245, 158, 11, 0.64);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.mc-seat-choice-selected:hover {\n  border-color: var(--mc-amber);\n  background: rgba(245, 158, 11, 0.14);\n}\n\n.mc-seat-choice-check {\n  margin-left: auto;\n  display: inline-flex;\n  height: 1.35rem;\n  width: 1.35rem;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--mc-divider);\n  border-radius: 999px;\n  color: transparent;\n}\n\n.mc-seat-choice-selected .mc-seat-choice-check {\n  border-color: var(--mc-amber);\n  background: var(--mc-amber);\n  color: var(--mc-bg);\n  box-shadow: 0 0 12px rgba(245, 158, 11, 0.42);\n}\n\n.mc-seat-tone-1 {\n  --mc-seat-color: var(--mc-cyan);\n  --mc-seat-border: rgba(29, 224, 197, 0.68);\n}\n\n.mc-seat-tone-2 {\n  --mc-seat-color: var(--mc-magenta);\n  --mc-seat-border: rgba(244, 122, 165, 0.68);\n}\n\n.mc-seat-tone-3 {\n  --mc-seat-color: var(--mc-purple);\n  --mc-seat-border: rgba(184, 85, 231, 0.68);\n}\n\n.mc-seat-tone-4 {\n  --mc-seat-color: var(--mc-green);\n  --mc-seat-border: rgba(95, 214, 146, 0.68);\n}\n\n.mc-seat-tone-1,\n.mc-seat-tone-2,\n.mc-seat-tone-3,\n.mc-seat-tone-4 {\n  background: var(--mc-seat-color);\n  border-color: var(--mc-seat-border);\n}\n\n.mc-seat-tone-1:hover,\n.mc-seat-tone-2:hover,\n.mc-seat-tone-3:hover,\n.mc-seat-tone-4:hover,\n.mc-seat-tone-1:focus-visible,\n.mc-seat-tone-2:focus-visible,\n.mc-seat-tone-3:focus-visible,\n.mc-seat-tone-4:focus-visible {\n  background: var(--mc-seat-color);\n  border-color: var(--mc-seat-border);\n}\n\n.mc-seat-marker,\n.mc-seat-choice-index {\n  background: var(--mc-seat-color) !important;\n  border-color: var(--mc-seat-border) !important;\n}\n\n.mc-seat-marker {\n  box-shadow: 0 0 12px var(--mc-seat-border);\n}\n\n.mc-seat-choice-index {\n  display: inline-flex;\n  height: 2.35rem;\n  width: 2.35rem;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: white;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 8px 18px -14px rgba(0, 0, 0, 0.9);\n}\n\n.mc-seat-choice-title {\n  color: var(--mc-text-primary);\n  font-weight: 700;\n}\n\n.mc-seat-choice-meta {\n  color: var(--mc-text-meta);\n  font-size: 0.75rem;\n}\n\n.mc-split-preview {\n  display: grid;\n  gap: 0.65rem;\n  border-color: rgba(245, 158, 11, 0.35);\n  background: rgba(245, 158, 11, 0.08);\n}\n\n/* Compact utility chip — for top-of-page navigation/links */\n.mc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--mc-white);\n  background: transparent;\n  border: 1px solid var(--mc-divider);\n  border-radius: 3px;\n  line-height: 1.2;\n  transition: color 160ms ease, border-color 160ms ease, background 160ms ease;\n  cursor: pointer;\n}\n\n.mc-chip:hover {\n  color: var(--mc-cyan);\n  border-color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.05);\n}\n\n.mc-chip-alert {\n  color: var(--mc-magenta);\n  border-color: rgba(244, 122, 165, 0.45);\n}\n\n.mc-chip-alert:hover {\n  color: var(--mc-magenta);\n  border-color: var(--mc-magenta);\n  background: rgba(244, 122, 165, 0.08);\n}\n\n.mc-ledger-action {\n  min-height: 2.6rem;\n  padding: 0.65rem 1rem;\n  font-size: 0.875rem;\n  letter-spacing: 0.01em;\n  border-radius: 4px;\n  border-width: 1px;\n}\n\n.mc-ledger-action-secondary {\n  color: var(--mc-amber);\n  border-color: rgba(245, 158, 11, 0.55);\n  background: rgba(245, 158, 11, 0.08);\n}\n\n.mc-ledger-action-secondary:hover {\n  color: var(--mc-amber);\n  border-color: var(--mc-amber);\n  background: rgba(245, 158, 11, 0.14);\n}\n\n.mc-ledger-action-primary {\n  color: var(--mc-bg);\n  border-color: var(--mc-cyan);\n  background: linear-gradient(135deg, var(--mc-cyan), rgba(95, 214, 146, 0.94));\n  box-shadow: 0 0 0 1px rgba(29, 224, 197, 0.18), 0 12px 28px -16px rgba(29, 224, 197, 0.85);\n}\n\n.mc-ledger-action-primary:hover {\n  color: var(--mc-bg);\n  border-color: var(--mc-cyan);\n  background: linear-gradient(135deg, var(--mc-cyan), rgba(125, 239, 180, 0.98));\n  box-shadow: 0 0 0 1px rgba(29, 224, 197, 0.28), 0 16px 34px -16px rgba(29, 224, 197, 0.95);\n}\n\n.mc-payment-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-height: 2.5rem;\n  width: 100%;\n  justify-content: center;\n  border: 1px solid var(--mc-divider);\n  border-radius: 4px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;\n}\n\n.mc-payment-action-accent {\n  color: var(--mc-cyan);\n  border-color: rgba(29, 224, 197, 0.42);\n  background: rgba(29, 224, 197, 0.1);\n}\n\n.mc-payment-action-accent:hover {\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.16);\n}\n\n.mc-payment-action-success {\n  color: var(--mc-green);\n  border-color: rgba(95, 214, 146, 0.42);\n  background: rgba(95, 214, 146, 0.1);\n}\n\n.mc-payment-action-success:hover {\n  color: var(--mc-green);\n  background: rgba(95, 214, 146, 0.16);\n}\n\n.mc-payment-action-danger {\n  color: var(--mc-magenta);\n  border-color: rgba(244, 122, 165, 0.42);\n  background: rgba(244, 122, 165, 0.1);\n}\n\n.mc-payment-action-danger:hover {\n  color: var(--mc-magenta);\n  background: rgba(244, 122, 165, 0.16);\n}\n\n.mc-receipt-focus-row {\n  border-radius: 6px;\n  outline: 1px solid rgba(244, 122, 165, 0.65);\n  outline-offset: 4px;\n  box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.12), 0 0 24px rgba(244, 122, 165, 0.18);\n  animation: mcReceiptFocus 1.35s ease-in-out 3;\n}\n\n@keyframes mcReceiptFocus {\n  0%, 100% {\n    box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.12), 0 0 20px rgba(244, 122, 165, 0.16);\n  }\n  50% {\n    box-shadow: 0 0 0 1px rgba(244, 122, 165, 0.28), 0 0 34px rgba(244, 122, 165, 0.36);\n  }\n}\n\n.mc-receipt-error-pulse {\n  animation: mcReceiptErrorPulse 2.2s ease-in-out infinite;\n}\n\n@keyframes mcReceiptErrorPulse {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(244, 122, 165, 0.18);\n  }\n  50% {\n    box-shadow: 0 0 0 3px rgba(244, 122, 165, 0.14), 0 0 22px rgba(244, 122, 165, 0.22);\n  }\n}\n\n.mc-chip-badge {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--mc-magenta);\n}\n\n/* Floating action cluster — primary POS actions, always reachable */\n.mc-fab-cluster {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  z-index: 40;\n}\n\n@media (min-width: 1536px) {\n  .mc-fab-cluster {\n    right: 244px;\n  }\n}\n\n.mc-fab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border: 1px solid var(--mc-divider);\n  background: var(--mc-bg);\n  color: var(--mc-white);\n  border-radius: 3px;\n  cursor: pointer;\n  box-shadow: 0 8px 24px -10px rgba(0, 0, 0, 0.7);\n  transition: all 160ms ease;\n}\n\n.mc-fab:hover {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n}\n\n.mc-fab-primary {\n  border-color: var(--mc-cyan);\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.08);\n}\n\n.mc-fab-primary:hover {\n  background: rgba(29, 224, 197, 0.16);\n}\n\n.mc-fab-secondary {\n  color: var(--mc-purple, #b855e7);\n  border-color: rgba(184, 85, 231, 0.4);\n}\n\n.mc-fab-secondary:hover {\n  color: var(--mc-purple, #b855e7);\n  border-color: var(--mc-purple, #b855e7);\n  background: rgba(184, 85, 231, 0.06);\n}\n\n/* Tab underline style */\n.mc-tab {\n  padding: 0.85rem 1.15rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--mc-gray);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: color 160ms ease, border-color 160ms ease;\n}\n\n.mc-tab:hover { color: var(--mc-white); }\n\n.mc-tab[data-state='active'],\n.mc-tab.mc-tab-active {\n  color: var(--mc-cyan);\n  border-bottom-color: var(--mc-cyan);\n}\n\n/* Venue node */\n.mc-node {\n  position: relative;\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border: 1px solid var(--mc-divider);\n  background: radial-gradient(circle at 50% 50%, rgba(29, 224, 197, 0.05), transparent 70%);\n  transition: all 200ms ease;\n}\n\n.mc-node-occupied {\n  border-color: var(--mc-cyan);\n  background: radial-gradient(circle at 50% 50%, rgba(29, 224, 197, 0.22), transparent 70%);\n  box-shadow: 0 0 24px rgba(29, 224, 197, 0.35), inset 0 0 24px rgba(29, 224, 197, 0.1);\n}\n\n.mc-node-completed {\n  border-color: var(--mc-purple);\n  background: radial-gradient(circle at 50% 50%, rgba(184, 85, 231, 0.18), transparent 70%);\n  box-shadow: 0 0 18px rgba(184, 85, 231, 0.25);\n}\n\n.mc-node-maintenance {\n  border-color: var(--mc-gray);\n  background: repeating-linear-gradient(\n    45deg,\n    transparent 0 4px,\n    rgba(139, 148, 158, 0.08) 4px 8px\n  );\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .mc-hero-number {\n    font-size: clamp(2.5rem, 10vw, 3.5rem);\n  }\n  .mc-node {\n    width: 64px;\n    height: 64px;\n  }\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .mc-pulse,\n  .mc-pulse-ring,\n  .mc-stream-entry,\n  .mc-stream-new--telegraph,\n  .mc-stream-new--telegraph::before,\n  .mc-attn-pulse,\n  .mc-receipt-focus-row,\n  .mc-receipt-error-pulse,\n  .mc-tick {\n    animation: none !important;\n  }\n  .mc-node,\n  .mc-btn,\n  .mc-tab {\n    transition: none !important;\n  }\n}\n\n/* Room tile hover */\n.mc-room-tile {\n  transition: background-color 140ms ease-out, border-color 140ms ease-out;\n}\n.mc-room-tile:hover {\n  background: var(--mc-bg-raised, rgba(29, 224, 197, 0.03)) !important;\n}\n\n/*\n * Attention bell (MCAttentionBell)\n * Header glyph + popover list of actionable items.\n */\n.mc-attn-bell {\n  background: transparent;\n}\n.mc-attn-bell:hover {\n  background: var(--mc-bg-raised, rgba(255, 255, 255, 0.03));\n}\n.mc-attn-bell:hover:not([data-has-items]) {\n  color: var(--mc-cyan) !important;\n}\n\n.mc-attn-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 14px;\n  height: 14px;\n  padding: 0 4px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 14px;\n  text-align: center;\n  color: #0c0f14;\n  letter-spacing: 0;\n  box-shadow: 0 0 0 1.5px var(--mc-bg, #0a0d12);\n}\n\n.mc-attn-pulse {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1.5px solid;\n  pointer-events: none;\n  animation: mcAttnPulse 1.4s ease-out infinite;\n}\n\n@keyframes mcAttnPulse {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n\n/* Popover open/close animation. Radix sets data-state on PopoverContent. */\n.mc-attn-popover[data-state='open'] {\n  animation: mcAttnPopoverIn 180ms cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n.mc-attn-popover[data-state='closed'] {\n  animation: mcAttnPopoverOut 120ms ease-in both;\n}\n\n@keyframes mcAttnPopoverIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes mcAttnPopoverOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n/* Row hover — uses the same raised surface as other MC affordances */\n.mc-attn-row > button:hover {\n  background: var(--mc-bg-raised, rgba(29, 224, 197, 0.04));\n}\n\n/* Resolving row: fade then collapse. Parent sets data-resolving=\"true\". */\n.mc-attn-row[data-resolving='true'] {\n  animation: mcAttnRowOut 350ms ease-in forwards;\n  overflow: hidden;\n}\n\n.mc-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-shrink: 0;\n}\n\n.mc-panel-header-tight {\n  margin-bottom: 0.5rem;\n}\n\n.mc-panel-header-flush {\n  margin-bottom: 0;\n}\n\n.mc-panel-header-bordered {\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--mc-divider-soft);\n}\n\n.mc-panel-header-title {\n  min-width: 0;\n}\n\n.mc-panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.mc-scroll-thin {\n  scrollbar-width: thin;\n}\n\n.mc-scroll-none {\n  scrollbar-width: none;\n}\n\n.mc-popover-panel {\n  box-shadow: 0 8px 32px rgba(29, 224, 197, 0.08), 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.mc-popover-content {\n  background: var(--mc-surface-raised, #0f1628);\n  border: 1px solid var(--mc-divider);\n  color: var(--mc-text-primary, var(--mc-white));\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);\n}\n\n.mc-dialog-content {\n  background: var(--mc-surface-raised, #0f1628);\n  border: 1px solid var(--mc-divider);\n  color: var(--mc-text-primary, var(--mc-white));\n  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.46), 0 0 28px rgba(29, 224, 197, 0.08);\n}\n\n.mc-dialog-frame {\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n  background: linear-gradient(180deg, rgba(15, 22, 40, 0.96) 0%, rgba(8, 12, 22, 0.96) 100%);\n}\n\n.mc-dialog-frame-accent {\n  position: absolute;\n  inset-inline: 0;\n  top: 0;\n  height: 1px;\n}\n\n.mc-dialog-header {\n  padding: 0.75rem 1.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n  border-bottom: 1px solid var(--mc-divider);\n}\n\n.mc-dialog-body {\n  padding: 1rem 1.25rem;\n}\n\n.mc-dialog-footer {\n  padding: 0.625rem 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  border-top: 1px solid var(--mc-divider);\n}\n\n.mc-dialog-footer-end {\n  justify-content: flex-end;\n}\n\n.mc-input {\n  background: transparent;\n  border: 1px solid var(--mc-divider);\n  border-radius: 4px;\n  color: var(--mc-text-primary, var(--mc-white));\n  padding: 0.5rem 0.75rem;\n  outline: none;\n}\n\n.mc-input.mc-input-currency {\n  padding-left: 1.9rem;\n}\n\n.mc-input[type='number'] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.mc-input[type='number']::-webkit-outer-spin-button,\n.mc-input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.mc-input:focus {\n  border-color: var(--mc-cyan);\n}\n\n.mc-code-block {\n  color: var(--mc-text-primary);\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid var(--mc-divider-soft);\n  border-radius: 3px;\n}\n\n.mc-status-badge {\n  border-width: 1px;\n  letter-spacing: 0.04em;\n}\n\n.mc-status-info {\n  color: var(--mc-purple);\n  border-color: rgba(184, 85, 231, 0.42);\n  background: rgba(184, 85, 231, 0.14);\n}\n\n.mc-status-success {\n  color: var(--mc-green);\n  border-color: rgba(95, 214, 146, 0.42);\n  background: rgba(95, 214, 146, 0.14);\n}\n\n.mc-status-danger {\n  color: var(--mc-magenta);\n  border-color: rgba(244, 122, 165, 0.42);\n  background: rgba(244, 122, 165, 0.14);\n}\n\n.mc-status-warning {\n  color: var(--mc-amber);\n  border-color: rgba(245, 158, 11, 0.42);\n  background: rgba(245, 158, 11, 0.12);\n}\n\n@keyframes mcAttnRowOut {\n  0% {\n    opacity: 1;\n    max-height: 120px;\n  }\n  40% {\n    opacity: 0;\n    max-height: 120px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    border-top-width: 0;\n  }\n}\n\n/* Original booking-detail layout prototype, rethemed with Mission Control tokens. */\n.mc-original-layout {\n  color: var(--mc-text-primary);\n}\n\n.mc-booking-shell {\n  width: 100%;\n  max-width: 1800px;\n  margin: 0 auto;\n  padding: 1rem 0.75rem;\n}\n\n@media (min-width: 640px) {\n  .mc-booking-shell {\n    padding: 2rem 1.5rem;\n  }\n}\n\n.mc-booking-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n@media (min-width: 1024px) {\n  .mc-booking-layout {\n    grid-template-columns: minmax(0, 2fr) minmax(19rem, 1fr);\n  }\n}\n\n.mc-booking-main,\n.mc-booking-side {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.mc-seat-detail-panel {\n  overflow: hidden;\n  padding: 0 !important;\n}\n\n.mc-seat-detail-header {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--mc-divider-soft);\n}\n\n.mc-seat-detail-body {\n  padding: 0.5rem 1rem 1rem;\n}\n\n@media (min-width: 640px) {\n  .mc-seat-detail-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .mc-seat-detail-body {\n    padding: 0.5rem 1.5rem 1.5rem;\n  }\n}\n\n.mc-original-layout [class*='bg-slate-800'],\n.mc-original-layout [class*='bg-slate-900'] {\n  background: var(--mc-surface) !important;\n}\n\n.mc-original-layout [class*='border-slate'] {\n  border-color: var(--mc-divider) !important;\n}\n\n.mc-original-layout [class*='text-slate-200'],\n.mc-original-layout [class*='text-slate-300'],\n.mc-original-layout [class*='text-slate-400'],\n.mc-original-layout [class*='text-white'] {\n  color: var(--mc-text-primary) !important;\n}\n\n.mc-original-layout [class*='text-slate-500'] {\n  color: var(--mc-text-meta-dim) !important;\n}\n\n.mc-original-layout [class*='text-amber-400'],\n.mc-original-layout .group:hover [class*='group-hover:text-amber-400'] {\n  color: var(--mc-cyan) !important;\n}\n\n.mc-original-layout [class*='bg-amber-500'],\n.mc-original-layout [class*='bg-amber-600'],\n.mc-original-layout [class*='from-amber'],\n.mc-original-layout [class*='to-orange'] {\n  background: rgba(29, 224, 197, 0.16) !important;\n}\n\n.mc-original-layout [class*='border-amber'],\n.mc-original-layout [class*='hover:border-amber'] {\n  border-color: rgba(29, 224, 197, 0.46) !important;\n}\n\n.mc-original-layout [class*='hover:bg-amber']:hover {\n  background: rgba(29, 224, 197, 0.1) !important;\n}\n\n.mc-original-layout button.bg-amber-500 {\n  color: var(--mc-bg) !important;\n  border-color: var(--mc-cyan) !important;\n  background: linear-gradient(135deg, var(--mc-cyan), rgba(95, 214, 146, 0.94)) !important;\n}\n\n.mc-original-layout [class*='bg-green'],\n.mc-original-layout [class*='bg-emerald'] {\n  background: rgba(95, 214, 146, 0.16) !important;\n}\n\n.mc-original-layout [class*='text-green'],\n.mc-original-layout [class*='text-emerald'] {\n  color: var(--mc-green) !important;\n}\n\n.mc-original-layout [class*='border-green'],\n.mc-original-layout [class*='border-emerald'] {\n  border-color: rgba(95, 214, 146, 0.42) !important;\n}\n\n.mc-original-layout [class*='bg-red'] {\n  background: rgba(244, 122, 165, 0.12) !important;\n}\n\n.mc-original-layout [class*='text-red'] {\n  color: var(--mc-magenta) !important;\n}\n\n.mc-original-layout [class*='border-red'] {\n  border-color: rgba(244, 122, 165, 0.42) !important;\n}\n\n.mc-original-layout [class*='bg-blue'],\n.mc-original-layout [class*='bg-sky'],\n.mc-original-layout [class*='bg-purple'],\n.mc-original-layout [class*='bg-pink'],\n.mc-original-layout [class*='from-purple'],\n.mc-original-layout [class*='to-pink'],\n.mc-original-layout [class*='from-sky'],\n.mc-original-layout [class*='to-blue'] {\n  background: rgba(184, 85, 231, 0.14) !important;\n}\n\n.mc-original-layout [class*='text-blue'],\n.mc-original-layout [class*='text-purple'] {\n  color: var(--mc-purple) !important;\n}\n\n.mc-original-layout [class*='border-blue'],\n.mc-original-layout [class*='border-purple'] {\n  border-color: rgba(184, 85, 231, 0.42) !important;\n}\n\n.mc-original-layout [class*='bg-gradient-to-r'] {\n  background-image: linear-gradient(90deg, var(--mc-cyan), var(--mc-purple)) !important;\n}\n\n.mc-original-layout [role='tablist'] {\n  background: var(--mc-surface-raised) !important;\n  border: 1px solid var(--mc-divider);\n}\n\n.mc-original-layout [role='tab'] {\n  color: var(--mc-text-meta);\n}\n\n.mc-original-layout [role='tab'][data-state='active'] {\n  color: var(--mc-cyan);\n  background: rgba(29, 224, 197, 0.1);\n}\n\n.mc-original-layout button {\n  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;\n}\n\n.mc-original-layout .border-t .mc-payment-action {\n  margin-left: -1px;\n  width: calc(100% + 2px);\n}\n\n.mc-original-layout .mc-booking-command-compact {\n  padding: 0.65rem 1rem;\n}\n\n.mc-original-layout .mc-booking-meta-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 1.25rem;\n  color: var(--mc-text-meta);\n  font-size: 0.8125rem;\n  line-height: 1.35;\n}\n\n.mc-original-layout .mc-booking-meta-item {\n  display: inline-flex;\n  min-width: 0;\n  align-items: center;\n  gap: 0.45rem;\n  white-space: nowrap;\n}\n\n.mc-original-layout .mc-seat-count-control {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem;\n  border: 1px solid var(--mc-divider) !important;\n  background: var(--mc-surface-raised) !important;\n}\n\n.mc-original-layout .mc-payment-total-compact {\n  padding: 0.7rem 0.8rem !important;\n}\n\n.mc-original-layout .mc-payment-seat-compact {\n  padding: 0.65rem;\n  border: 1px solid var(--mc-divider);\n  background: var(--mc-surface-raised);\n}\n\n.mc-original-layout .mc-payment-seat-compact .mc-panel-header {\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.mc-original-layout .mc-payment-seat-status {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 0.75rem;\n  padding: 0.42rem 0.55rem;\n  border: 1px solid transparent !important;\n  border-radius: 0.45rem;\n  background: rgba(6, 12, 24, 0.5) !important;\n  font-size: 0.8125rem;\n  text-align: left;\n}\n\n.mc-original-layout .mc-payment-seat-status:hover {\n  border-color: rgba(29, 224, 197, 0.35) !important;\n  background: rgba(29, 224, 197, 0.06) !important;\n}\n\n.mc-original-layout .mc-payment-seat-status-active {\n  border-color: rgba(29, 224, 197, 0.55) !important;\n  background: rgba(29, 224, 197, 0.1) !important;\n  box-shadow: inset 0 0 14px rgba(29, 224, 197, 0.05);\n}\n\n.mc-original-layout .mc-menu-tool {\n  height: auto;\n  min-height: 2.5rem;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  padding: 0.55rem 0.7rem;\n  border: 1px solid var(--mc-divider) !important;\n  background: var(--mc-surface-raised) !important;\n  color: var(--mc-text-primary) !important;\n  font-size: 0.8125rem;\n  font-weight: 500;\n}\n\n.mc-original-layout .mc-menu-tool:hover {\n  border-color: rgba(29, 224, 197, 0.45) !important;\n  background: rgba(29, 224, 197, 0.08) !important;\n  color: var(--mc-cyan) !important;\n}\n\n.mc-original-layout .mc-menu-item {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0.7rem 0.85rem;\n  border: 1px solid var(--mc-divider) !important;\n  border-radius: 0.4rem;\n  background: var(--mc-surface-raised) !important;\n  text-align: left;\n}\n\n.mc-original-layout .mc-menu-item:hover {\n  border-color: rgba(29, 224, 197, 0.45) !important;\n  background: rgba(29, 224, 197, 0.07) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
